import React from 'react';
import { Briefcase, Calendar, TrendingUp, Bell } from 'lucide-react';
import CTASection from '../../components/CTASection';

const PortfolioManagementPage = () => {
  return (
    <div>
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Trademark <span className="text-[#FF6B35]">Portfolio Management</span></h1>
          <p className="text-xl text-gray-300 max-w-3xl">Comprehensive management of your entire trademark portfolio with deadline tracking, renewals, and strategic planning.</p>
        </div>
      </div>
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
            <p>Managing multiple trademarks across jurisdictions requires constant attention to deadlines, renewals, and maintenance filings. Our portfolio management service handles everything so you can focus on building your business.</p>
            <p>We track all critical deadlines, file maintenance documents, coordinate international registrations, analyze portfolio strengths and gaps, and provide strategic recommendations for expansion and protection.</p>
          </div>
        </div>
      </div>
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 text-center">
              <Calendar className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Deadline Tracking</h3>
              <p className="text-gray-700 text-sm">Never miss renewal or maintenance deadlines</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Bell className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Automated Alerts</h3>
              <p className="text-gray-700 text-sm">Proactive notifications before deadlines</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <TrendingUp className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Strategic Analysis</h3>
              <p className="text-gray-700 text-sm">Portfolio gap analysis and recommendations</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Briefcase className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Central Dashboard</h3>
              <p className="text-gray-700 text-sm">View all trademarks in one place</p>
            </div>
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
};

export default PortfolioManagementPage;